class BrandDirectory extends HTMLElement {
  connectedCallback() {
    this.search = this.querySelector('[data-brand-search]');
    this.source = [...this.querySelectorAll('[data-brand-source]')];
    this.groups = this.querySelector('[data-brand-groups]');
    this.empty = this.querySelector('[data-brand-empty]');
    this.buttons = [...this.querySelectorAll('[data-brand-filter]')];
    this.buildGroups();
    this.search?.addEventListener('input', () => this.applySearch());
    this.buttons.forEach((button) => button.addEventListener('click', () => this.handleFilter(button)));
  }

  normalize(value) {
    return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  getLetter(name) {
    const first = this.normalize(name).charAt(0).toUpperCase();
    return /^[A-Z]$/.test(first) ? first : '#';
  }

  buildGroups() {
    if (!this.groups || !this.source.length) return;
    const byLetter = {};
    this.source.forEach((link) => {
      const name = link.dataset.brandName || link.textContent.trim();
      const letter = this.getLetter(name);
      (byLetter[letter] ||= []).push({name, href: link.href});
    });

    Object.values(byLetter).forEach((items) => items.sort((a,b) => a.name.localeCompare(b.name, 'es', {sensitivity:'base'})));
    const letters = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
    if (byLetter['#']) letters.push('#');

    const fragment = document.createDocumentFragment();
    letters.forEach((letter) => {
      const items = byLetter[letter];
      const button = this.querySelector(`[data-brand-filter="${letter}"]`);
      if (!items?.length) { if (button) button.disabled = true; return; }

      const section = document.createElement('section');
      section.className = 'brand-directory__group';
      section.id = `${this.id}-${letter === '#' ? 'other' : letter}`;
      section.dataset.brandGroup = letter;
      const title = document.createElement('h2');
      title.className = 'brand-directory__group-title';
      title.textContent = letter;
      const grid = document.createElement('div');
      grid.className = 'brand-directory__grid';

      items.forEach(({name, href}) => {
        const a = document.createElement('a');
        a.className = 'brand-directory__brand';
        a.href = href;
        a.textContent = name;
        a.dataset.brandItem = '';
        a.dataset.search = this.normalize(name);
        grid.appendChild(a);
      });
      section.append(title, grid);
      fragment.appendChild(section);
    });
    this.groups.replaceChildren(fragment);
  }

  applySearch() {
    const query = this.normalize(this.search?.value);
    let visible = 0;
    this.querySelectorAll('[data-brand-group]').forEach((group) => {
      let groupVisible = 0;
      group.querySelectorAll('[data-brand-item]').forEach((item) => {
        const show = !query || item.dataset.search.includes(query);
        item.hidden = !show;
        if (show) { groupVisible++; visible++; }
      });
      group.hidden = groupVisible === 0;
    });
    this.empty?.classList.toggle('is-visible', visible === 0);
    this.setActive('all');
  }

  handleFilter(button) {
    const filter = button.dataset.brandFilter;
    if (filter === 'all') {
      if (this.search) this.search.value = '';
      this.applySearch();
      this.scrollIntoView({behavior:'smooth', block:'start'});
      return;
    }
    if (this.search) this.search.value = '';
    this.applySearch();
    const target = this.querySelector(`[data-brand-group="${filter}"]`);
    target?.scrollIntoView({behavior:'smooth', block:'start'});
    this.setActive(filter);
  }

  setActive(filter) {
    this.buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.brandFilter === filter));
  }
}
customElements.define('brand-directory', BrandDirectory);
